export const PRAPARE_INFO = 'PRAPARE_INFO';
export const MARRIOT_AHC_SCREENER_INFO = 'MarriotAHCScreener_INFO';

export const constructTableValue = (ansItem, index, data) => {
    let type = ansItem?.answerControlType;
    switch (type) {
        case 105:
            let textAnsArr = data?.[index]?.textAns;
            let hasValue = textAnsArr?.length > 0 && textAnsArr.find((ans) => ans.answerInternalId === ansItem?.answerInternalIdentifier);
            let finalValue = hasValue?.answer ? (type === 109 || type === 121 ? new Date(hasValue?.answer) : hasValue?.answer) : '';
            return finalValue;

        default:
            return '';
    }
};
